

























































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Thumb from '@/components/molecules/Thumb/Thumb.vue';
import CoinsIcon from '@/components/icons/Coins.vue';

@Component({
  components: {
    FilledButton,
    Thumb,
    CoinsIcon
  }
})
export default class CustomerImportEmailPreview extends Vue {
  @Prop() coinsPerCustomer!: number;
  @Prop({ default: '16px' }) baseFont?: string;

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get email() {
    return 'yourcustomer@email.com';
  }

  get rewardsRate() {
    const { coinRewardPercentage = 0 } = this.businessInfo;

    return Number.parseFloat(coinRewardPercentage);
  }

  get businessLogo() {
    const business = this.businessInfo;

    if (!business) return '';

    return business.logo.publicPath.large;
  }
}
